var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.874 12C18.3336 10.4644 20 7.5135 20 4.125C20 3.74363 19.9783 3.369 19.9383 3H4.06172C4.02031 3.37361 3.99971 3.74917 4 4.125C4 7.5135 5.66526 10.4644 8.12487 12C5.66526 13.5356 4 16.4865 4 19.875C4 20.2564 4.02172 20.631 4.06172 21H19.9383C19.9794 20.631 20 20.2564 20 19.875C20 16.4865 18.3336 13.5356 15.874 12ZM5.71327 19.875C5.71327 16.5889 7.14537 13.8034 9.71355 12.8843V11.1158C7.14537 10.1966 5.71327 7.41 5.71327 4.125H18.2856C18.2856 7.41113 16.8535 10.1966 14.2853 11.1158V12.8843C16.8535 13.8034 18.2856 16.59 18.2856 19.875H5.71327ZM13.9219 14.7697C12.6418 14.0554 12.572 13.1284 12.5709 12.5659V11.4364C12.5709 10.8739 12.6383 9.9435 13.9241 9.228C14.6122 8.83537 15.2065 8.238 15.6568 7.49888H8.34203C8.79349 8.238 9.38896 8.83538 10.077 9.22913C11.3571 9.9435 11.4268 10.8705 11.428 11.433V12.5625C11.428 13.125 11.3605 14.0554 10.0747 14.7709C8.77749 15.5122 7.8117 16.9804 7.51911 18.75H16.4786C16.186 16.9792 15.2191 15.5111 13.9207 14.7697H13.9219Z",
    fill: "#ED7047",
    stroke: "#ED7047",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingTable);
export default __webpack_public_path__ + "static/media/pending-table.ece842699add15cce22b776eb1ea08f9.svg";
export { ForwardRef as ReactComponent };